<template>
  <div id="home">
    <!--    <img class="christmas-decoration-1" :src="ChristmasDecoration" alt="">-->
    <!--    <img class="christmas-decoration-2" :src="ChristmasDecoration2" alt="">-->
    <div class="home-choose-site">
      <div v-if="isKaraokeSite()" class="choose-site karaoke">
        <span>Karaoke Studio D<sup>TM</sup></span>
        <check-icon />
      </div>
      <div v-if="!isKaraokeSite()" class="choose-site matrice">
        <span>Matrice Studio D<sup>TM</sup></span>
        <check-icon />
      </div>
      <a
        v-if="!isKaraokeSite()"
        :href="getExternalSiteUrl('https://karaokestudiod.com')"
        class="choose-site karaoke"
        :title="`${$t('goTo')}Karaoke Studio D`"
      >
        <change-icon />
        <span>Karaoke Studio D<sup>TM</sup></span>
      </a>
      <a
        v-if="isKaraokeSite()"
        :href="getExternalSiteUrl('https://muzickematrice.com')"
        class="choose-site matrice"
        :title="`${$t('goTo')}Matrice Studio D`"
      >
        <change-icon />
        <span>Matrice Studio D<sup>TM</sup></span>
      </a>
    </div>
    <div class="welcome-block">
      <div class="d-flex align-center justify-center">
        <div class="d-flex align-center">
          <div class="rotating-logo">
            <img class="logo" :src="DarkLogo" alt="logo" />
            <!--              <img v-if="theme === 'dark'" :src="LightLogo" alt="logo" />-->
          </div>
          <h1 v-if="isKaraokeSite()">Karaoke Studio D<sup>TM</sup></h1>
          <h1 v-else>Matrice Studio D<sup>TM</sup></h1>
        </div>
      </div>
      <p>{{ $t("welcome_message") }}</p>
    </div>
    <div class="landing-artists-sliders">
      <div class="see-all justify-center">
        <router-link to="/artists" class="home-action-btn">
          <mic-icon v-if="isKaraokeSite()" />
          <download-icon v-if="!isKaraokeSite()" />
          <span v-if="isKaraokeSite()">{{$t('sing_songs')}}</span>
          <span v-if="!isKaraokeSite()">{{$t('download_songs')}}</span>
        </router-link>
      </div>
      <div class="slider slider-1">
        <div class="slide-track">
          <div
            v-for="(artist, i) in randomArtistsFirstRow"
            :key="i + '-artist-' + '1-' + artists[artist].name"
            class="slide"
          >
            <img :src="artists[artist].src" alt="" />-->
          </div>
          <div
            v-for="(artist, i) in randomArtistsFirstRow"
            :key="i + '-artist-' + '2-' + artists[artist].name"
            class="slide"
          >
            <img :src="artists[artist].src" alt="" />-->
          </div>
        </div>
      </div>
      <div class="slider slider-2">
        <div class="slide-track">
          <div
            v-for="(artist, i) in randomArtistsSecondRow"
            :key="i + '-artist-' + '1-' + artists[artist].name"
            class="slide"
          >
            <img :src="artists[artist].src" alt="" />-->
          </div>
          <div
            v-for="(artist, i) in randomArtistsSecondRow"
            :key="i + '-artist-' + '2-' + artists[artist].name"
            class="slide"
          >
            <img :src="artists[artist].src" alt="" />-->
          </div>
        </div>
      </div>
      <div class="slider slider-3">
        <div class="slide-track">
          <div
            v-for="(artist, i) in randomArtistsThirdRow"
            :key="i + '-artist-' + '1-' + artists[artist].name"
            class="slide"
          >
            <img :src="artists[artist].src" alt="" />-->
          </div>
          <div
            v-for="(artist, i) in randomArtistsThirdRow"
            :key="i + '-artist-' + '2-' + artists[artist].name"
            class="slide"
          >
            <img :src="artists[artist].src" alt="" />-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getArtists } from "@/services/songs";
import DarkLogo from "@/assets/logo.svg";
import LightLogo from "@/assets/logo-white.svg";
import ChristmasDecoration from "@/assets/christmas-decoration.png";
import ChristmasDecoration2 from "@/assets/christmas-decoration-2.png";
import { isKaraokeSite } from "@/services/utils";
import CheckIcon from "./svg/CheckIcon.vue";
import ChangeIcon from "./svg/ChangeIcon.vue";
import MicIcon from "./svg/MicIcon.vue";
import DownloadIcon from "./svg/DownloadIcon.vue";

export default {
  name: "home",
  components: {DownloadIcon, MicIcon, ChangeIcon, CheckIcon },
  data() {
    return {
      theme: "light",
      artists: [],
      randomArtistsFirstRow: [],
      randomArtistsSecondRow: [],
      randomArtistsThirdRow: [],
      loading: true,
      DarkLogo,
      LightLogo,
      ChristmasDecoration,
      ChristmasDecoration2,
    };
  },
  metaInfo() {
    const origin = typeof window !== 'undefined' ? window.location.origin : '';
    const isKaraoke = typeof this.isKaraokeSite === 'function' ? this.isKaraokeSite() : this.isKaraokeSite;

    const fullTitle = isKaraoke
        ? "Karaoke Studio D - Početna"
        : "Matrice Studio D - Početna";

    return {
      title: fullTitle,
      meta: [
        {
          hid: "description",
          name: "description",
          content: "✔ Slusaj ✔ Pevaj ✔ Pretplati se, Preko 10000 matrica na jednom mestu, samo 9.99€ mesečno!",
        },
        {
          hid: "twitter:card",
          name: "twitter:card",
          content: "Karaoke",
        },
        {
          hid: "twitter:site",
          name: "twitter:site",
          content: "@matricestudiod",
        },
        {
          hid: "twitter:title",
          name: "twitter:title",
          content: fullTitle,
        },
        {
          hid: "twitter:description",
          name: "twitter:description",
          content: "✔ Slusaj ✔ Pevaj ✔ Pretplati se, Preko 10000 matrica na jednom mestu, samo 9.99€ mesečno!",
        },
        {
          hid: "twitter:creator",
          name: "twitter:creator",
          content: "@matricestudiod",
        },
        {
          hid: "twitter:image",
          name: "twitter:image",
          content: "https://karaokesrbija.com/api/stream/LOGO.jpg",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: fullTitle,
        },
        {
          hid: "og:url",
          property: "og:url",
          content: origin,
        },
        {
          hid: "og:image",
          property: "og:image",
          content: "https://karaokesrbija.com/api/stream/LOGO.jpg",
        },
        {
          hid: "og:description",
          property: "og:description",
          content: "✔ Slusaj ✔ Pevaj ✔ Pretplati se, Preko 10000 matrica na jednom mestu, samo 9.99€ mesečno",
        },
        {
          hid: "og:site_name",
          property: "og:site_name",
          content: isKaraoke ? "Karaoke Studio D" : "Matrice Studio D",
        },
        {
          hid: "og:type",
          property: "og:type",
          content: "website",
        },
        {
          hid: "robots",
          name: "robots",
          content: "index,follow",
        },
      ],
    };
  },
  computed: {
    isLogged() {
      return this.$store.state.isLogged;
    },
  },
  methods: {
    isKaraokeSite,
    // selectArtist: function (artist) {
    //   this.$router.push("/artist/" + artist.name);
    // },
    tryGetArtists() {
      let self = this;
      getArtists(function (data) {
        if (data.error) {
          self.$emit("show-snackbar", data.payload.data.status, "error");
          self.$router.push("/");
        } else {
          data.payload.forEach((item) => {
            const src = "/api/stream/" + item.replace(/ /g, "") + ".jpg";
            const artist = { name: item, src };
            self.artists.push(artist);
          });
          self.getRandomArtists();
        }
      });
    },
    getRandomArtists() {
      const self = this;
      const arr = Array.from({ length: 38 }, (_, i) => i + 1);
      self.randomArtistsFirstRow = arr.slice(0, 12);
      self.randomArtistsSecondRow = arr.slice(13, 24);
      self.randomArtistsThirdRow = arr.slice(25, 36);
    },
    getTheme() {
      if (localStorage.getItem("theme")) {
        this.theme = localStorage.getItem("theme");
      } else {
        localStorage.setItem("theme", "light");
        this.theme = localStorage.getItem("theme");
      }
    },
    getExternalSiteUrl(baseUrl) {
      // If a user is logged in, append the authentication token
      const token = localStorage.getItem("karaoke-user-token");
      if (this.isLogged && token) {
        return `${baseUrl}?auth_token=${encodeURIComponent(token)}`;
      }
      return `${baseUrl}?auth_token=lgt`;
    },
  },
  mounted() {
    this.getTheme();
    this.tryGetArtists();
  },
};
</script>
